import React from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';

import Footer from "./Footer";

const GalleryPage = (props) => {
  const outlets = props.galleryCategories.filter((outlet) => { return outlet.name === "outlet" })
  console.log('props.galleryCategories', props.galleryCategories)
  console.log('outlets', outlets)
  const slider = props.galleryCategories.filter((slider) => { return slider.name === "slider" })

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3.9999,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };
  return props === undefined ? (
    <div className="loading">
    </div>
  ) : (
    <>
      <div className="galleryPage">
        <div className="container-fluid gallerySlide">
          <div className="row">
            <h4 className='galleryh4 inPage'> GALLERY</h4>
            <Slider {...sliderSettings} >
              {slider[0].galleries.map((gallery) => {
                return (
                  <div className="galleryImages" key={gallery.id}><img src={process.env.REACT_APP_IMAGE_STORAGE + gallery.image} alt="" className="galleryImage" /></div>
                )
              })}
            </Slider>
          </div>
        </div>
        <div className="outlets">
          <div className="container-fluid">
            <div className="row outletsRow d-flex justify-content-center">
              {outlets[0].galleries
                .filter(outlet => outlet.gallery_content.toUpperCase() !== "GRAFFITI")
                .map((outlet) => {
                  return (
                    <div className="outletWrap col-lg-3" key={outlet.id}>
                      <h5>{outlet.gallery_title}</h5>
                      <Link to={`/gallery/${outlet.gallery_content}`}><img src={process.env.REACT_APP_IMAGE_STORAGE + outlet.image} alt={outlet.gallery_content} className="outletGalleryPic" /></Link>
                      <h5>{outlet.gallery_content}</h5>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="footer d-lg-none">
        <Footer />
      </div>
    </>
  );
};

export default GalleryPage;